import type IExercise from '../../../models/pa-egna-ben/exercise.model';
import type ILegReport from '../../../models/pa-egna-ben/leg-report.model';
import { ExerciseLevel } from '../../../models/pa-egna-ben/exercise-level.enum';

export enum ExerciseStatus {
  completed = 'completed',
  notCompleted = 'not-completed',
}

export default class ExerciseHelper {
  public static calculateExerciseStatus(exercise: IExercise, legReports: ILegReport[] | undefined): ExerciseStatus {
    return legReports?.some((legReport) => legReport.completedExercises?.some((ex) => ex === exercise.id)) ? ExerciseStatus.completed : ExerciseStatus.notCompleted;
  }

  public static parseExerciseLevel(value: string): ExerciseLevel {
    if (value in ExerciseLevel) {
      return ExerciseLevel[value as keyof typeof ExerciseLevel];
    }
    return ExerciseLevel.easy;
  }
}
